import React, {useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import { withFormik } from 'formik';

import Validations from 'utils/Validations';
import { sendGeneralFromData } from 'redux/forms/actions';
import store from 'redux/store';
import { Input, Button } from 'components/commons';
import {useAppSelector} from "../../redux/hooks";
import {createSelector} from "reselect";

const memoizedSelector = createSelector(
    state => state.users.currentUser.userLoaded,
    state => state.users.currentUser.data,
    state => state.sellers.currentSeller,
    (currentUserLoaded, currentUserData, currentSeller) => ({ currentUserLoaded, currentUserData, currentSeller})
);

const GeneralForm = (props) => {
    const {
        values,
        touched,
        errors,
        isSubmitting,
        handleChange,
        handleBlur,
        handleSubmit,
        setModalOpen,
    } = props;

    const { t } = useTranslation();

    const { currentUserLoaded, currentUserData, currentSeller } = useAppSelector(memoizedSelector)
    const [isNotAvailableForSLA, setIsNotAvailableForSLA] = useState(false)

    useEffect(() => {

        if (currentUserLoaded) {
            values.email = currentUserData.email;
        }

        if (currentSeller && currentSeller.info.data && currentSeller.info.data.id) {
            values.seller = currentSeller.info.data.id;
            setIsNotAvailableForSLA(!['high', 'increased'].includes(currentSeller.info.data.sla || ''))
        }
    }, [currentSeller, currentUserLoaded, currentUserData])

    React.useEffect(() => {
        if (isSubmitting) {
            setTimeout(() => {
                setModalOpen(false)
            }, 3000)
        }
    }, [isSubmitting, setModalOpen])

    return (
        <>
            <form action="" id='generalForm' onSubmit={handleSubmit}>

                <div className="px-5 py-4">
                    <div className="space-y-3">
                        <div>
                            <Input
                                placeholder="mail@mail.ru"
                                id="inviteEmail"
                                type="email"
                                name="inviteEmail"
                                value={values.inviteEmail}
                                label={t("Email", { ns: "messages" })}
                                changeHandler={handleChange}
                                customLabelClassName="text-sm"
                                blurHandler={handleBlur}
                                validationError={errors && errors.inviteEmail && errors.inviteEmail.length > 0}
                                validationErrorDescription={errors.inviteEmail}
                            />
                            {errors.inviteEmail && touched.inviteEmail && (<div className="text-xs text-left mt-2 text-red-500 input-feedback">{errors.inviteEmail}</div>)}
                        </div>
                    </div>
                </div>

                <div className={`inline-flex min-w-fit md:min-w-80 my-4 mx-5 px-4 py-2 rounded-sm text-sm bg-white border border-gray-200 text-gray-600`}>
                    <div className="flex w-full justify-between items-start">
                        <div className="flex">
                            <svg className="w-4 h-4 flex-shrink-0 fill-current text-indigo-500 mt-[3px] mr-3"
                                 viewBox="0 0 16 16">
                                <path
                                    d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"></path>
                            </svg>
                            <div className="text-xs	">
                                <div>Внимание, сотрудник уже должен быть зарегистрирован на Платформе</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal footer */}
                <div className="px-5 py-4 border-t border-gray-200">
                    <div className="flex flex-wrap justify-start space-x-2 mt-4">
                        <Button
                            type="submit"
                            appearance="primary"
                            customClassName="btn-sm"
                            loading={isSubmitting}
                            disabled={isNotAvailableForSLA}
                        >
                            {t("Send", { ns: "messages" })}
                        </Button>

                        {isNotAvailableForSLA &&
                            <div className="flex pl-3 items-center">
                                <svg className="w-4 h-4 flex-shrink-0 fill-current text-yellow-500 mr-2" viewBox="0 0 16 16">
                                    <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"></path>
                                </svg>
                                <div className="text-xs">
                                    <div>Функция доступна для <a href={"https://lk.market/ru/pricing"} className="mb-2" style={{color: "rgb(37 99 235)"}} rel="noreferrer" target="_blank">коммерческих тарифов</a>.</div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </form>
        </>
    )
}

const CreateGeneralForm = ({callbackId, setModalOpen}) => {



    const GeneralFormWithValidation = withFormik({
        mapPropsToValues: () => ({ inviteEmail: '', email: '', seller: null}),
        validate: values => {
            let errors = {};

            const validation = Validations();

            Object.keys(values).forEach((key) => validation[key] && validation[key](errors, values[key]))

            return errors;
        },

        handleSubmit: (values, { setSubmitting }) => {
            setSubmitting(false);
            store.dispatch(sendGeneralFromData({
                data: values,
            }, callbackId))
        },
    })(GeneralForm);


    return <GeneralFormWithValidation setModalOpen={setModalOpen} />

}

export default CreateGeneralForm;